import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Cover from './components/Cover';
import Main from './components/Main';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import { pageStatistics } from '@ifeng-fe/mobile_statistics';

const Layout = ({ content }) => {
    const [showCover, setShowCover] = useState(true);

    const closeCover = () => {
        setShowCover(false);
        pageStatistics({
            behavior: 'action',
            type: 'wdcwjy_kq',
        });
    };

    useEffect(() => {
        pageStatistics({
            behavior: 'page',
            type: 'wdcwjy_t',
            ref: 'other',
            id: 'wdcwjy_id',
        });
    }, []);

    return (
        <div className={styles.layout}>
            <div id="ifeng_share_url" style={{ display: 'none' }}>
                https://ent.ifeng.com/loc/chunwan2022
            </div>
            <div id="ifeng_share_title" style={{ display: 'none' }}>
                点击获取你和春晚的“独家记忆”
            </div>
            <div id="ifeng_share_thumbnail" style={{ display: 'none' }}>
                https://x0.ifengimg.com/ucms/2023_03/15E29D901DEE279F0B0C69A974FC0BC687D8B488_size89_w688_h688.jpg
            </div>
            <div id="ifeng_share_description" style={{ display: 'none' }}>
                不只是经典节目，还有那些温暖的旧时光...
            </div>
            <Cover show={showCover} close={closeCover} />
            <Main />
            <QQShare
                content={{
                    title: '点击获取你和春晚的“独家记忆”',
                    img:
                        'https://x0.ifengimg.com/ucms/2023_03/15E29D901DEE279F0B0C69A974FC0BC687D8B488_size89_w688_h688.jpg',
                    desc: '不只是经典节目，还有那些温暖的旧时光...',
                    cb: () => {
                        console.log('分享成功');
                    },
                }}
            />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
